import mountDynamicComponent from '~/plugins/mountDynamicComponent';
import Confirmation from '~/components/Plugins/Confirmation.vue';

export default defineNuxtPlugin(
    mountDynamicComponent({
        component: Confirmation,
        functionName: 'showConfirmation'
    })
);